var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-field" }, [
    !_vm.hideLabel && _vm.label
      ? _c(
          "label",
          {
            class: {
              "required-flag":
                _vm.required && !_vm.readonly ? _vm.showFlag : false,
            },
          },
          [_vm._v(_vm._s(_vm.label) + _vm._s(_vm.showColon ? ":" : ""))]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.readonlyAsInput && _vm.readonly
      ? _c("span", [_vm._v(_vm._s(_vm.showReadOnlyText))])
      : _vm._e(),
    _vm._v(" "),
    _vm.readonlyAsInput || !_vm.readonly
      ? _c("div", { staticClass: "row text-input" }, [
          _vm.hintBeforeInput
            ? _c("p", { class: _vm.hintClass }, [
                _vm._v(_vm._s(_vm.hintBeforeInput)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              { name: "autosize", rawName: "v-autosize" },
              {
                name: "hkldinput",
                rawName: "v-hkldinput",
                value: {
                  component: _vm.parentNode,
                  unchecked: !_vm.dirtyCheck,
                },
                expression: "{ component: parentNode, unchecked: !dirtyCheck }",
              },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: _vm.fusionInputCheckBinding,
                expression: "fusionInputCheckBinding",
              },
            ],
            class: [
              { "small-2 medium-2 large-2 columns": _vm.text },
              _vm.extendClass,
            ],
            attrs: {
              disabled: _vm.readonlyAsInput,
              placeholder: _vm.placeholder,
              required: _vm.required,
            },
            domProps: { value: _vm.value },
            on: {
              blur: _vm.onChange,
              input: _vm.onInput,
              change: _vm.onChange,
            },
          }),
          _vm._v(" "),
          _vm.text
            ? _c("pre", { class: { "additional-text": _vm.text } }, [
                _c("p", [_vm._v(_vm._s(_vm.text))]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }